import Vue from 'vue'
import VueI18nManager from 'vue-i18n-manager'
import store from '@/store'
import router from '@/router'
import { LANGUAGES } from '@/constants/languages'

const proxy = {
  getTranslation: async (lang) => {
    return await store.dispatch(`setting/GET_TRANSLATIONS`, lang.key)
  },
}

Vue.use(VueI18nManager, {
  store,
  router,
  proxy,
  config: {
    defaultCode: 'cz-CZ',
    languages: LANGUAGES,
    translations: proxy,
  },
})
